import React, { useState } from "react";
import { Space, Select, Input } from "antd";
import {
  BANNER_PLACEMENT,
  BANNER_PLACEMENT_LABEL,
} from "../../constants/bannerPlacement";

const BannerFilters = ({ filters, onFiltersChange }) => {
  return (
    <Space size="large">

      <div>
        Active :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 120 }}
          allowClear
          onChange={(value) => onFiltersChange({ ...filters, isActive: value })}
        >
          <Select.Option value={true}>Yes</Select.Option>
          <Select.Option value={false}>No</Select.Option>
        </Select>
      </div>

      <div>
        Placement :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 180 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, placement: value ?? null })
          }
        >
          {Object.values(BANNER_PLACEMENT).map((placement) => (
            <Select.Option key={placement} value={placement}>
              {BANNER_PLACEMENT_LABEL[placement]}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Space>
  );
};

export default BannerFilters;
